/**
 * Frost Theme Sound Configuration
 *
 * Ice/Crystalline-themed sounds for the Frost/Cyan 3D board theme
 * Features crisp, clean, crystalline sounds that evoke winter and ice
 * Includes sounds for movement, hard drop, line clear, and tetris finisher
 */

import iceMovementSound from '../../../../assets/sounds/themes/frost/ice-movement.wav';
import iceHardDropSound from '../../../../assets/sounds/themes/frost/ice-harddrop.wav';
import iceLineClearSound from '../../../../assets/sounds/themes/frost/ice-lineclear.wav';
import iceFinisherSound from '../../../../assets/sounds/themes/frost/ice-finisher.wav';
import rotateBlockSoundPath from '../../../../assets/sounds/rotateBlockTrimmed.wav';

export const FROST_SOUND_CONFIG = {
  name: 'Frost',
  description: 'Crystalline ice-themed sounds for Frost board',

  // Theme sound definitions
  sounds: {
    // Crisp ice crackle/crystalline chime for piece movements (left/right/down/rotate)
    // Should sound like delicate ice crystals forming or shifting
    movement: {
      src: iceMovementSound,
      volume: 0.35,    // Slightly softer for elegant, refined feel
      rate: 1.0
    },

    // Sharp ice impact/shatter for hard drop
    // Think of an icicle hitting frozen ground - crisp and satisfying
    hardDrop: {
      src: iceHardDropSound,
      volume: 0.55,
      rate: 1.0
    },

    // Gentle crystalline shimmer for single line clears (1 line)
    // Like ice crystals tinkling or a frozen wind chime
    lineClear: {
      src: iceLineClearSound,
      volume: 0.5,
      rate: 1.0
    },

    // Epic glacial cascade for multi-line clears (2+ lines)
    // Imagine an avalanche of ice crystals or a frozen waterfall
    tetris: {
      src: iceFinisherSound,
      volume: 0.65,
      rate: 1.0
    },

    // Failed rotation sound
    rotateBlock: {
      src: rotateBlockSoundPath,
      volume: 0.5,
      rate: 1.0
    }
  },

  /**
   * Mappings from game sound keys to theme sound keys
   *
   * Game sound keys (from utilities.js):
   * - fall: Piece movement (left/right/down/rotate success)
   * - rotateBlockSound: Failed rotation attempt
   * - whipSound: Hard drop impact
   * - blasterSound: Line clear laser effect
   * - deliciousSound: Tetris (4-line clear) celebration
   *
   * Set to null to use default sound (no theme override)
   */
  mappings: {
    fall: 'movement',              // Movement sounds → crystalline ice crackle
    rotateBlockSound: 'rotateBlock', // Failed rotation → rotateBlock.wav
    whipSound: 'hardDrop',         // Hard drop → sharp ice impact
    blasterSound: 'lineClear',     // Single line clear → gentle crystalline shimmer
    deliciousSound: 'tetris'       // Multi-line finisher (2+) → epic glacial cascade
  }
};

export default FROST_SOUND_CONFIG;
